define.alias("ember-math-helpers/helpers/atanh", "media/helpers/atanh");